/**
 * Track clicks using Google Analytics
 * @author Ryan Gladstone
 * <tab click-tracker='homepage tasks tabs' click-action='clicked on 'mine''>
 * </tab>
 */

function clickTracker(analyticsService) {
  function clickTrackerLink($scope, elm, attrs) {
    elm.on('click', () => {
      analyticsService.trackEvent(attrs.clickTracker, attrs.clickAction);
    });
  }

  return {
    restrict: 'A',
    scope: {
      clickAction: '@'
    },
    link: clickTrackerLink
  };
}

const clickTrackerArray = [
  'analyticsService',
  clickTracker
];

export default function (ngModule) {
  ngModule.directive('clickTracker', clickTrackerArray);
}
